const SvgZillow = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
    className="fill-gray-primary hover:fill-blue-600 cursor-pointer inline"
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M10.028 4.315c.073-.017.105.008.15.057.252.28 1.058 1.264 1.277 1.532.04.049.012.102-.02.13C9.808 7.303 7.998 9.1 6.99 10.385c-.02.03-.004.03.012.025 1.757-.757 5.884-1.965 7.743-2.302V5.754L7.47 0 .184 5.75v2.573c2.256-1.34 7.477-3.42 9.844-4.008Z" />
    <path d="M4.108 14.203c-.061.033-.11.024-.16-.024L2.592 12.56c-.037-.045-.041-.07.008-.138 1.05-1.537 3.192-3.932 4.558-4.945.025-.016.017-.036-.012-.024-1.423.464-5.469 2.204-6.965 3.05V16H14.74v-5.294c-1.984.337-7.929 2.106-10.633 3.497Z" />
  </svg>
);

const SvgMobile = ({ className }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M17.25 0H6.75C5.09297 0 3.75 1.34297 3.75 3V21C3.75 22.657 5.09297 24 6.75 24H17.25C18.907 24 20.25 22.657 20.25 21V3C20.25 1.34297 18.9047 0 17.25 0ZM18 21C18 21.4135 17.6635 21.75 17.25 21.75H6.75C6.33656 21.75 6 21.4125 6 21V3C6 2.58647 6.33647 2.25 6.75 2.25H17.25C17.6625 2.25 18 2.58656 18 3V21ZM13.5 18.75H10.5C10.0858 18.75 9.75 19.0858 9.75 19.5C9.75 19.9142 10.0858 20.25 10.5 20.25H13.5C13.9143 20.25 14.25 19.9142 14.25 19.5C14.25 19.0858 13.9125 18.75 13.5 18.75Z" />
  </svg>
);

const SvgBusiness = ({ className }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.33333 18.6666H8C8.73417 18.6666 9.33333 18.0674 9.33333 17.3333V2.66659C9.33333 1.93242 8.73417 1.33325 8 1.33325H5.33333C4.6 1.33325 4 1.93242 4 2.66659V17.3333C4 18.0666 4.6 18.6666 5.33333 18.6666ZM22 2.66659H10.6667V17.3333C10.6667 18.802 9.46875 19.9999 8 19.9999H5.33333C3.86458 19.9999 2.66667 18.802 2.66667 17.3333V2.66659H2C0.895833 2.66659 0 3.56242 0 4.66659V20.6666C0 21.7708 0.895833 22.6666 2 22.6666H22C23.1042 22.6666 24 21.7708 24 20.6666V4.66659C24 3.56242 23.1042 2.66659 22 2.66659ZM16 19.3333C16 19.703 15.7031 19.9999 15.3333 19.9999H14C13.6302 19.9999 13.3333 19.703 13.3333 19.3333V17.9999C13.3333 17.6301 13.6302 17.3333 14 17.3333H15.3333C15.7031 17.3333 16 17.6301 16 17.9999V19.3333ZM16 13.9999C16 14.3697 15.7031 14.6666 15.3333 14.6666H14C13.6292 14.6666 13.3333 14.3708 13.3333 13.9999V12.6666C13.3333 12.2958 13.6292 11.9999 14 11.9999H15.3333C15.7042 11.9999 16 12.2958 16 12.6666V13.9999ZM21.3333 19.3333C21.3333 19.703 21.0365 19.9999 20.6667 19.9999H19.3333C18.9635 19.9999 18.6667 19.703 18.6667 19.3333V17.9999C18.6667 17.6301 18.9635 17.3333 19.3333 17.3333H20.6667C21.0365 17.3333 21.3333 17.6301 21.3333 17.9999V19.3333ZM21.3333 13.9999C21.3333 14.3697 21.0365 14.6666 20.6667 14.6666H19.3333C18.9625 14.6666 18.6667 14.3708 18.6667 13.9999V12.6666C18.6667 12.2958 18.9625 11.9999 19.3333 11.9999H20.6667C21.0375 11.9999 21.3333 12.2958 21.3333 12.6666V13.9999ZM21.3333 9.33325H13.3333V5.33325H21.3333V9.33325Z"
      fill="#666666"
    />
  </svg>
);

const SvgSendCard = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <mask id="path-1-inside-1_2042_3283" fill="white">
      <rect width="20" height="15" rx="1.33339" />
    </mask>
    <rect
      width="20"
      height="15"
      rx="1.33339"
      stroke="currentColor"
      strokeWidth="4"
      mask="url(#path-1-inside-1_2042_3283)"
    />
    <path d="M11 7H4" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    <path d="M11 4H4" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    <path d="M16 10H4" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    <rect x="13" y="3" width="4" height="4" rx="1" fill="currentColor" />
  </svg>
);

const SvgHome = ({ className }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M23.6458 9.90421C24.0667 10.2625 24.1208 10.8917 23.7625 11.3125C23.4042 11.7334 22.775 11.7875 22.3542 11.4292L21.3333 10.5625V18.3334C21.3333 20.175 19.8417 21.6667 18 21.6667H6C4.15916 21.6667 2.66667 20.175 2.66667 18.3334V10.5625L1.64708 11.4292C1.22583 11.7875 0.594998 11.7334 0.237498 11.3125C-0.119793 10.8917 -0.0680851 10.2625 0.35304 9.90421L11.3542 0.570874C11.725 0.254207 12.275 0.254207 12.6458 0.570874L23.6458 9.90421ZM6 19.6667H8V13.3334C8 12.4125 8.74583 11.6667 9.66667 11.6667H14.3333C15.2542 11.6667 16 12.4125 16 13.3334V19.6667H18C18.7375 19.6667 19.3333 19.0709 19.3333 18.3334V8.86671L12 2.64462L4.66667 8.86671V18.3334C4.66667 19.0709 5.2625 19.6667 6 19.6667ZM10 19.6667H14V13.6667H10V19.6667Z"
      fill="#666666"
    />
  </svg>
);

const SvgAreaPro = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 62 64"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path fill="currentColor" d="M46.5621 10.7259C43.0423 8.80989 39.1461 7.6865 35.1465 7.43444C34.6121 3.79444 34.2558 1.43231 34.2558 1.43231C34.2005 1.02584 33.9998 0.653193 33.6908 0.383391C33.3817 0.11359 32.9854 -0.03508 32.5752 -0.03508C32.165 -0.03508 31.7687 0.11359 31.4597 0.383391C31.1507 0.653193 30.9499 1.02584 30.8946 1.43231L30.1202 7.51963C18.5031 8.82074 7.92388 17.1463 5.16677 29.4448C4.71456 31.3176 4.46785 33.2342 4.43102 35.1604L1.14727 35.2843C0.842551 35.3087 0.558191 35.447 0.35083 35.6716C0.143468 35.8962 0.0283203 36.1907 0.0283203 36.4964C0.0283203 36.8021 0.143468 37.0966 0.35083 37.3212C0.558191 37.5458 0.842551 37.684 1.14727 37.7084L4.48523 37.8323C4.79221 42.1934 6.09458 46.4261 8.29234 50.2054C10.4901 53.9846 13.5248 57.21 17.1633 59.6336C17.4249 59.7804 17.7321 59.8232 18.0239 59.7535C18.3156 59.6838 18.5703 59.5068 18.7374 59.2577C18.9044 59.0086 18.9715 58.7057 18.9252 58.4094C18.8789 58.113 18.7227 57.845 18.4876 57.6587C15.2508 55.4334 12.5597 52.5041 10.6162 49.0906C8.67269 45.6771 7.52719 41.8678 7.26558 37.9485L13.4226 38.1654L15.1806 42.1771C15.2783 42.396 15.4202 42.5923 15.5975 42.7536C15.7748 42.9148 15.9836 43.0376 16.2107 43.1142C16.64 43.2513 17.1061 43.2135 17.5077 43.0091C17.9094 42.8046 18.2142 42.45 18.356 42.0222L19.2389 39.2883L23.3281 62.3056C23.4038 62.7022 23.618 63.0591 23.9325 63.3125C24.2469 63.5659 24.6411 63.6994 25.0448 63.6892C25.4485 63.6789 25.8355 63.5256 26.1367 63.2566C26.4378 62.9876 26.6337 62.6204 26.6893 62.2204L32.7146 14.2033L37.4311 46.1424C37.4857 46.5078 37.6576 46.8455 37.9208 47.1047C38.184 47.3639 38.5244 47.5306 38.8906 47.5795C39.2567 47.6284 39.6289 47.557 39.951 47.3761C40.273 47.1951 40.5276 46.9143 40.6762 46.5761L42.8524 41.5498C44.3239 46.336 46.1439 51.037 49.6755 54.8784L49.7607 54.9481L51.3096 56.2957C51.7466 56.6552 52.3046 56.8339 52.8692 56.795C53.4337 56.7561 53.962 56.5026 54.3455 56.0866C67.225 42.27 63.3061 19.4929 46.5621 10.7259ZM24.7144 50.6885C23.2351 42.2313 21.3996 32.0083 21.3996 32.0083C21.3345 31.6356 21.1472 31.2951 20.8672 31.0406C20.5872 30.7861 20.2304 30.632 19.8531 30.6027C19.4758 30.5734 19.0996 30.6706 18.7836 30.8788C18.4676 31.087 18.23 31.3945 18.1081 31.7528L16.4972 36.7094L16.11 35.811V35.7568C15.9799 35.4584 15.762 35.2066 15.4853 35.0351C15.2086 34.8635 14.8862 34.7803 14.5611 34.7964L7.26558 35.0597C7.35007 33.3927 7.60966 31.7391 8.04005 30.1264C9.26382 25.1076 12.0003 20.5862 15.8791 17.1743C19.7578 13.7624 24.5913 11.6249 29.7252 11.0512L24.7144 50.6885ZM52.4481 51.5327C50.6175 49.4915 49.1223 47.1728 48.0181 44.6632C46.7951 41.8663 45.7197 39.0071 44.7963 36.0975C44.6968 35.7638 44.4968 35.4688 44.2237 35.2526C43.9507 35.0364 43.6176 34.9096 43.2699 34.8893C42.9222 34.869 42.5767 34.9562 42.2803 35.1391C41.9839 35.322 41.751 35.5918 41.6133 35.9117L39.9249 39.784L35.6808 11.0667C40.1184 11.5786 44.3386 13.2672 47.9044 15.9578C51.4702 18.6484 54.252 22.2431 55.962 26.3699C57.6719 30.4967 58.2478 35.0055 57.63 39.4296C57.0122 43.8537 55.2232 48.0322 52.4481 51.5327Z" />
  </svg>
);

export {
  SvgHome,
  SvgBusiness,
  SvgMobile,
  SvgZillow,
  SvgSendCard,
  SvgAreaPro,
};
